import {
  ComponentStyleProps,
  componentStylePropsOf,
} from "../../../../lib/styles/props/component-style-props";
import {
  chakra,
  ComponentMultiStyleConfig,
  Input,
  useMultiStyleConfig,
} from "@chakra-ui/react";
import React, { ChangeEvent, useCallback, useId } from "react";
import { CMFrameButtonPopupSearchCondition } from "../CMFrameButtonPopupSearchCondition/CMFrameButtonPopupSearchCondition";

export type CMButtonPopupSearchConditionDatalistFreeProps<
  T extends string | number,
> = {
  labelSubmit?: string;
  labelClear?: string;

  /**
   * クリアボタンの表示制御 trueの場合にクリアボタン非表示
   */
  hideClearButton?: boolean;

  options: { label: string; value: T }[];

  inputText: string;
  onChangeInputText: (inputText: string) => void;

  onSubmit: () => void;
  onClear: () => void;
} & ComponentStyleProps;

/**
 * データリスト検索条件のコンポーネント。
 * 値オブジェクトを指定せず、自由に選択肢を指定できるバージョン。
 *
 * 注意: datalistの性質上、値だけでなくラベルも一意でないと、うまく動かない。
 */
export const CMButtonPopupSearchConditionDatalistFree = <
  T extends string | number,
>({
  labelSubmit,
  labelClear,
  hideClearButton = false,

  options,

  inputText,
  onChangeInputText,

  onSubmit,
  onClear,

  sx,
  ...rest
}: CMButtonPopupSearchConditionDatalistFreeProps<T>) => {
  const styles = useMultiStyleConfig(
    "CMButtonPopupSearchConditionDatalistFreeStyles",
    {},
  );

  const handleChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      onChangeInputText(e.target.value ?? "");
    },
    [onChangeInputText],
  );

  const id = useId();

  return (
    <CMFrameButtonPopupSearchCondition
      labelSubmit={labelSubmit}
      labelClear={labelClear}
      hideClearButton={hideClearButton}
      onSubmit={onSubmit}
      onClear={onClear}
      {...rest}
      sx={{ ...styles.container, ...sx }}
    >
      <Input type="text" list={id} onChange={handleChange} value={inputText} />
      <chakra.datalist id={id}>
        {options.map((option, index) => (
          <chakra.option key={index} value={option.label} sx={styles.option} />
        ))}
      </chakra.datalist>
    </CMFrameButtonPopupSearchCondition>
  );
};

export const CMButtonPopupSearchConditionDatalistFreeStyles: ComponentMultiStyleConfig =
  {
    parts: ["container", "radioStack", "option", "optionLabel"],
    baseStyle: {
      container: {},
      radioStack: {
        alignItems: "flex-start",
      },
      option: {
        mt: 0,
      },
      optionLabel: {},
    },
  };
